import $ from 'jquery'

if (!window.$) {
    window.$ = window.jQuery = $
}